/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_PhotoInputs */

const en_story_photo = /** @type {(inputs: Story_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

const es_story_photo = /** @type {(inputs: Story_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

const fr_story_photo = /** @type {(inputs: Story_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo`)
};

const de_story_photo = /** @type {(inputs: Story_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

const id_story_photo = /** @type {(inputs: Story_PhotoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foto`)
};

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const ja_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const zh_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const ar_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const it_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const ru_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const pt_story_photo = en_story_photo;

/** @type {(inputs: Story_PhotoInputs) => LocalizedString} */
const ko_story_photo = en_story_photo;

/**
* | output |
* | --- |
* | "Photo" |
*
* @param {Story_PhotoInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_photo = /** @type {((inputs?: Story_PhotoInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_PhotoInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_photo(inputs)
	if (locale === "es") return es_story_photo(inputs)
	if (locale === "fr") return fr_story_photo(inputs)
	if (locale === "de") return de_story_photo(inputs)
	if (locale === "ja") return ja_story_photo(inputs)
	if (locale === "zh") return zh_story_photo(inputs)
	if (locale === "ar") return ar_story_photo(inputs)
	if (locale === "id") return id_story_photo(inputs)
	if (locale === "it") return it_story_photo(inputs)
	if (locale === "ru") return ru_story_photo(inputs)
	if (locale === "pt") return pt_story_photo(inputs)
	return ko_story_photo(inputs)
});